// extracted by mini-css-extract-plugin
module.exports = {"error":"conditional-issue-text_error__38qpJ","warning":"conditional-issue-text_warning__XQAf_","errorWrapper":"conditional-issue-text_errorWrapper__D26AK"};